import { combineReducers } from '@reduxjs/toolkit';

// Legacy ABIE
import adminConfigReducer from './admin/reducers';
import cliniciansReducer from './clinicians/slice';
// Legacy OBIE
import cliniciansGlobalReducer from './cliniciansGlobal/slice';
import errorHandlerReducer from './errorHandlers/reducers';
import filtersReducer from './filters/reducers';
import insuranceReducer from './insurance/reducers';
import matchesReducer from './matches/reducers';
import patientReducer from './patient/reducer';
import preferencesReducer from './preferences/reducers';
import reservationReducer from './reservation/reducer';
import reservationGlobalReducer from './reservationGlobal/reducers';
import searchesReducer from './searches/reducers';
import sessionReducer from './session/reducers';
import userReducer from './user/reducer';
import userGlobalReducer from './userGlobal/reducers';

const baseReducer = combineReducers({
  // Legacy ABIE
  filters: filtersReducer,
  config: adminConfigReducer,
  user: userReducer,
  reservation: reservationReducer,
  clinicians: cliniciansReducer,
  // Legacy OBIE
  preferences: preferencesReducer,
  matches: matchesReducer,
  userGlobal: userGlobalReducer,
  reservationGlobal: reservationGlobalReducer,
  insurance: insuranceReducer,
  errorHandler: errorHandlerReducer,
  searches: searchesReducer,
  session: sessionReducer,
  cliniciansGlobal: cliniciansGlobalReducer,
  patient: patientReducer,
});

export default baseReducer;
